import { createSlice } from '@reduxjs/toolkit';
import type { PersonalLearningState } from './types';

const initialState: PersonalLearningState = {
  isLoading: false,
  error: false,
  pathways: [],
  upNextTopics: [],
  topicsPagination: {
    total: 0,
    page: 1,
    pageSize: 10,
    draftTopics: []
  },
  circleGoalsOverview: []
};

export const slice = createSlice({
  name: 'personalLearning',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    getMyPathways(state, action) {
      state.pathways = action.payload.items;
    },
    fetchUpNextTopicsSuccess(state, action) {
      state.upNextTopics = action.payload;
    },
    fetchDraftTopicsSuccess(state, action) {
      state.topicsPagination = {
        ...action.payload.pagination,
        draftTopics: [...state.topicsPagination.draftTopics, ...action.payload.data].filter(
          (topic) => !state.upNextTopics.some((ft) => ft.topicGuid === topic.topicGuid)
        )
      };
    },
    clearDraftTopics(state) {
      state.topicsPagination.draftTopics = [];
    },
    removeUpNextTopic(state, action) {
      state.upNextTopics = state.upNextTopics.filter(
        (topic) => topic.topicGuid !== action.payload.topicGuid
      );
      state.topicsPagination.draftTopics = [action.payload, ...state.topicsPagination.draftTopics];
    },
    addUpNextTopic(state, action) {
      state.upNextTopics.push(action.payload);
      state.topicsPagination.draftTopics = state.topicsPagination.draftTopics.filter(
        (topic) => topic.topicGuid !== action.payload.topicGuid
      );
    },
    fetchCircleGoalsOverviewSuccess(state, action) {
      state.circleGoalsOverview = action.payload;
    }
  }
});

export default slice.reducer;
